import Vue from 'vue'
import VueResource from 'vue-resource'
import mixins from '../mixins.js'
import MoneyBoxHistory from '../../component/view/MoneyBoxHistory.vue'
import WalletHistory from '../../component/view/WalletHistory.vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import DatePicker from '../../component/dccore-form/datePicker.vue'
import Moment from 'moment'
import toastr from '../toastr'
import History from './history.vue'

if ($('#client_show').length) {
  Vue.use(VueResource)
  new Vue({
    el: '#client_show',
    components: {
      MoneyBoxHistory,
      Singleselect,
      DatePicker,
      WalletHistory,
      History
    },
    mixins: [mixins],
    data () {
      return {
        addressId: null,
        changeFromAddress: null,
        changeToAddress: null,
        loading: 0,
        formSending: false,
        changeFromDate: new Date(),
        allAddresses: [],
        dontShowInactiveAddresses: true,
        addressesOfSameType: [],
        form: {
          options: {
            errors: {}
          }
        }
      }
    },
    computed: {
      getFormattedDate () {
        return (new Moment(this.changeFromDate)).format('ll')
      },
      addressesOfSameTypeActive () {
        return this.addressesOfSameType.filter(address => address.isActive)
      }
    },
    watch: {
      changeFromAddress (newVal) {
        if (newVal !== null && typeof newVal === 'number') {
          this.changeToAddress = null
          this.getAddressesTo()
        }
      }
    },
    mounted: function () {
      this.getAddresses()
    },
    methods: {
      getAddresses () {
        this.loading++
        let url = Routing.generate('api_get_addresses', {
          'user': window.appValues.clientId,
          date: '1980-01-01',
          context: 'dropdown'
        })

        this.$http.get(url).then(response => {
          this.allAddresses = response.data
          this.allAddresses = this.allAddresses.filter(address => address.isActive)
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getAddressesTo () {
        this.loading++
        let url = Routing.generate('api_get_addresses', {
          'user': window.appValues.clientId,
          date: '1980-01-01',
          context: 'dropdown'
        })
        this.$http.get(url).then(response => {
          this.addressesOfSameType = response.data.filter((address) => {
            return address.id !== this.changeFromAddress
          })
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      changeAddressOnBags () {
        this.formSending = true
        const routeName = 'api_patch_address_change_address_on_feature_bags'
        const url = Routing.generate(routeName, {
          fromAddress: this.changeFromAddress,
          toAddress: this.changeToAddress,
          date: (new Moment(this.changeFromDate)).format('YYYY-MM-DD')
        })
        this.$http.patch(url).then(() => {
          this.formSending = false
          toastr.success(this.trans('form.updated'))
        }, response => {
          this.formSending = false
          this.handleAjaxError(response, this.form.options)
        })
      }
    }
  })
}
